<template>
  <div>
    <v-text-field
      label="Placeholder"
      v-model="localValue.placeholder"
      hide-details
    ></v-text-field>
  </div>
</template>

<script>
export default {
  props: {
    value: Object,
  },
  data() {
    return {
      localValue: { ...this.value },
    };
  },
  watch: {
    localValue: {
      deep: true,
      immediate: true,
      handler() {
        this.$emit("update", {
          ...this.localValue,
        });
      },
    },
  },
};
</script>

<style></style>
